export const ROOM_LIVE_VIEW_AUTOPLAY_POLICY_ENABLED_DEFAULT = true;
